
const state = {
  languageType: [
    {
      testEntry: {
        welcome: "欢迎进入竹子！",
        feedback: '进入意见反馈',
        customPage: '进入自定义页面',
        userAgreement: '进入用户协议',
        privacyAgreement: '进入隐私协议'
      },
      feedback: {
        footSend: {
          send: '发送',
          textareaDesc: '有什么问题，快输入问我～',
          yuyinDesc: '按住说话'
        },
        footButton: '联系客服',
        button: {
          submit: '提交',
          supplement: '补充',
          resolved: '已解决'
        },
        tip:{
          mobile: '请输入有效的手机号码!',
          success: '您的问题已经反馈成功！',
          urlErr: '您访问的地址不正确,请确认地址及参数',
          paramsErr: '您访问的地址参数不正确,请确认参数',
          thanks: '感谢您的反馈！',
          complaintErr: '客诉信息有误！'
        },
        formLabel:{
          desc: '问题描述',
          mobile: '手机号码',
          email: '邮箱地址',
          image: '图片上传',
          imageMax: '(最多上传5张图片,5MB以下)'
        },
        placeholder:{
          desc: '请输入详细描述问题的细节（字数不少于5字）',
          mobile: '请输入手机号码(必填)',
          email: '请输入邮箱地址(选填)',
          image: '图片上传',
          imageMax: '(最多上传5张图片,5MB以下)',
          reDesc: '请输入详细描述问题的细节（字数不少于2字',
        },
        complaint: {
          noMore: '暂无更多记录',
          problem: '问题',
          need: '请完善',
          unfinished: '未结束',
          roleId: '角色ID',
          roleServer: '角色区服',
          roleName: '角色名称',
          progress: '服务进度',
          seeServer: '查看服务',
          help: '帮助中心',
          problemType1: '充值问题',
          problemType2: '常见问题',
          problemType3: '进入问题',
          problemType4: '功能问题',
          ctime: '提交时间',
          mtime: '客服受理',
          desc: '详细描述',
          history: '历史回复',
          rtime: '回复时间',
          customer: '客服',
          me: '我',

        },
        upload: {
          uploadMax: '图片最多上传',
          reselectImg: '张图片,请重选图片',
        }
      }
    },
    {
      testEntry: {
        welcome: "歡迎進入竹子！",
        feedback: '進入意見回饋',
        customPage: '進入自定義頁面',
        userAgreement: '進入使用者協定',
        privacyAgreement: '進入隱私協定'
      },
      feedback: {
        footSend: {
          send: '發送',
          textareaDesc: '有什麼問題，快輸入問我～',
          yuyinDesc: '按住說話'
        },
        footButton: '聯繫客服',
        button: {
          submit: '提交',
          supplement: '補充',
          resolved: '已解决'
        },
        tip:{
          mobile: '請輸入有效的手機號碼！',
          success: '您的問題已經回饋成功！',
          urlErr: '您訪問的地址不正確,請確認地址及參數',
          paramsErr: '您訪問的地址參數不正確,請確認參數',
          thanks: '感謝您的回饋！',
          complaintErr: '客訴資訊有誤！'
        },
        formLabel:{
          desc: '問題描述',
          mobile: '手機號碼',
          email: '信箱地址',
          image: '圖片上傳',
          imageMax: '（最多上傳5張圖片,5MB以下）'
        },
        placeholder:{
          desc: '請輸入詳細描述問題的細節（字數不少於5字）',
          mobile: '請輸入手機號碼（必填）',
          email: '請輸入信箱地址（選填）',
          image: '圖片上傳',
          imageMax: '（最多上傳5張圖片,5MB以下）',
          reDesc: '請輸入詳細描述問題的細節（字數不少於2字',
        },
        complaint: {
          noMore: '暫無更多記錄',
          problem: '問題',
          need: '請完善',
          unfinished: '未結束',
          roleId: '角色ID',
          roleServer: '角色區服',
          roleName: '角色名稱',
          progress: '服務進度',
          seeServer: '查看服務',
          help: '幫助中心',
          problemType1: '儲值問題',
          problemType2: '常見問題',
          problemType3: '進入問題',
          problemType4: '功能問題',
          ctime: '提交時間',
          mtime: '客服受理',
          desc: '詳細描述',
          history: '歷史回覆',
          rtime: '回覆時間',
          customer: '客服',
          me: '我',
        },
        upload: {
          uploadMax: '圖片最多上傳',
          reselectImg: '張圖片,請重選圖片',
        }
      }
    },
  ],
  lang: {}
}

if (window.language === 'cn') {
  state.lang = state.languageType[0]
} else {
  state.lang = state.languageType[1]
}
const getters = {
  lang: state => state.lang
}

export default {
  state,
  getters
}

